<template>
  <div :class="$style.container">
    <SettingsPagePanel v-if="policy">
      <SettingsPagePanelHeader>
        <template #title>アクセスコントロール詳細</template>
        <template #right>
          <RouterLink
            :to="{
              name: 'authzPolicySettingEdit',
              params: {
                authzPolicySettingGuid: policy.guid,
                entranceGUID: entranceGUID,
              },
            }"
          >
            <FlatButton>編集</FlatButton>
          </RouterLink>
        </template>
      </SettingsPagePanelHeader>
      <SettingsTable :class="$style.table">
        <SettingsTableRow name="名前">
          <p :class="$style.text">{{ policy.name }}</p>
        </SettingsTableRow>
        <SettingsTableRow name="許可/禁止">
          <p :class="$style.text">{{ AuthzPolicyEffectText[policy.effect] }}</p>
        </SettingsTableRow>
        <SettingsTableRow name="適用対象スタッフ">
          <p :class="$style.text">
            {{ AuthzPolicyPrincipalTypeText[policy.principal.__typename] }}
          </p>
        </SettingsTableRow>
        <SettingsTableRow name="操作名">
          <p :class="$style.text">
            {{ AuthzPolicyActionTypeText[policy.action.__typename] }}
          </p>
        </SettingsTableRow>
        <SettingsTableRow name="操作対象">
          <p :class="$style.text">
            {{ AuthzPolicyResourceTypeText[policy.resource.__typename] }}
          </p>
        </SettingsTableRow>
      </SettingsTable>
      <div :class="$style.delete">
        <FlatButton
          variant="caution"
          size="medium"
          @click="deletePolicy"
          :disabled="deleting"
        >
          削除
        </FlatButton>
      </div>
    </SettingsPagePanel>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { captureException as newrelicCaptureException } from '@/newrelic'

import { useAlert } from '@/libs/alertPortal'
import SettingsTable from '@/pages/SettingsPage/SettingsTable/SettingsTable.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'

import SettingsTableRow from '../SettingsTable/SettingsTableRow.vue'
import SettingsPagePanel from '../SettingsPagePanel.vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'
import {
  useSettingsPageAuthzPolicyDetailViewQuery,
  useDeleteAuthzPolicyMutation,
} from './SettingsPageAuthzPolicyDetailView.generated'
import {
  AuthzPolicyEffectText,
  AuthzPolicyPrincipalTypeText,
  AuthzPolicyActionTypeText,
  AuthzPolicyResourceTypeText,
} from './types'

const alert = useAlert()
const router = useRouter()
const route = useRoute('authzPolicySettingDetail')
const authzPolicyGuid = route.params.authzPolicySettingGuid
const entranceGUID = route.params.entranceGUID
const { result } = useSettingsPageAuthzPolicyDetailViewQuery(
  {
    guid: authzPolicyGuid,
  },
  {
    fetchPolicy: 'no-cache',
  }
)

const { mutate } = useDeleteAuthzPolicyMutation()

const policy = computed(() => {
  return result.value?.authzPolicy
})

const deleting = ref(false)

const deletePolicy = async () => {
  const confirmResult = window.confirm(
    '本当に削除しますか？この操作は取り消せません。'
  )
  if (!confirmResult) {
    return
  }

  deleting.value = true

  // TODO: ログを送る(バックエンドで送るんだっけ？確認する)
  await mutate({
    input: {
      guid: authzPolicyGuid,
    },
  })
    .then(() => {
      // eslint-disable-next-line fp/no-mutating-methods
      router.push({ name: 'authzPolicySetting' })
    })
    .catch(e => {
      newrelicCaptureException(e)
      alert.error(
        'エラーが発生しました。再度お試しいただくか、サポートにお問い合わせください。'
      )
    })
    .finally(() => {
      deleting.value = false
    })
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.delete {
  text-align: center;
  margin-top: 40px;
}
</style>
